import { fn, hash } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import routeAction from "discourse/helpers/route-action";
import DropdownSelectBox from "discourse/select-kit/components/dropdown-select-box";
import DButton from "discourse/ui-kit/d-button";
import dAgeWithTooltip from "discourse/ui-kit/helpers/d-age-with-tooltip";
import { i18n } from "discourse-i18n";

const CollapsedInfo = <template>
  <PluginOutlet
    @name="user-profile-above-collapsed-info"
    @outletArgs={{lazyHash model=@model collapsedInfo=@collapsedInfo}}
  />
  {{#unless @collapsedInfo}}
    <div class="secondary" id="collapsed-info-panel">
      <dl>
        {{#if @model.created_at}}
          <div>
            <dt class="created-at">{{i18n "user.created"}}</dt>
            <dd class="created-at">
              {{dAgeWithTooltip @model.created_at format="medium"}}
            </dd>
          </div>
        {{/if}}
        {{#if @model.last_posted_at}}
          <div>
            <dt class="last-posted-at">{{i18n "user.last_posted"}}</dt>
            <dd class="last-posted-at">
              {{dAgeWithTooltip @model.last_posted_at format="medium"}}
            </dd>
          </div>
        {{/if}}
        {{#if @model.last_seen_at}}
          <div>
            <dt class="last-seen-at">{{i18n "user.last_seen"}}</dt>
            <dd class="last-seen-at">
              {{dAgeWithTooltip @model.last_seen_at format="medium"}}
            </dd>
          </div>
        {{/if}}
        {{#if @model.profile_view_count}}
          <div><dt class="profile-view-count">{{i18n "views"}}</dt><dd
              class="profile-view-count"
            >{{@model.profile_view_count}}</dd></div>
        {{/if}}
        {{#if @model.invited_by}}
          <div><dt class="invited-by">{{i18n "user.invited_by"}}</dt><dd
              class="invited-by"
            ><LinkTo
                @model={{@model.invited_by}}
                @route="user"
              >{{@model.invited_by.username}}</LinkTo></dd></div>
        {{/if}}
        {{#if @hasTrustLevel}}
          <div><dt class="trust-level">{{i18n "user.trust_level"}}</dt><dd
              class="trust-level"
            >{{@model.trustLevel.name}}</dd></div>
        {{/if}}
        {{#if @canCheckEmails}}
          <div><dt class="email">{{i18n "user.email.title"}}</dt>
            <dd class="email" title={{@model.email}}>
              {{#if @model.email}}
                {{@model.email}}
              {{else}}
                <DButton
                  class="btn-small btn-primary"
                  @action={{fn (routeAction "checkEmail") @model}}
                  @icon="envelope"
                  @label="admin.users.check_email.text"
                />
              {{/if}}
            </dd>
          </div>
        {{/if}}
        {{#if @model.displayGroups}}
          <div><dt class="groups">{{i18n
                "groups.title"
                count=@model.displayGroups.length
              }}</dt>
            <dd class="groups">
              {{#each @model.displayGroups as |group|}}
                <span><LinkTo
                    class="group-link"
                    @model={{group.name}}
                    @route="group"
                  >{{group.name}}</LinkTo></span>
              {{/each}}

              <LinkTo @query={{hash username=@model.username}} @route="groups">
                ...
              </LinkTo>
            </dd>
          </div>
        {{/if}}

        {{#if @canDeleteUser}}
          <div class="pull-right">
            <DropdownSelectBox
              class="btn-small btn-delete-user"
              @content={{@adminDeleteOptions}}
              @nameProperty="label"
              @onChange={{@adminDelete}}
              @options={{hash
                icon="triangle-exclamation"
                showCaret=true
                translatedNone=(i18n "user.admin_delete")
                customStyle=true
                btnCustomClasses="btn-danger"
              }}
            />
          </div>
        {{/if}}

        <PluginOutlet
          @name="user-profile-secondary"
          @outletArgs={{lazyHash model=@model}}
        />
      </dl>
    </div>
  {{/unless}}
</template>;

export default CollapsedInfo;
